import { render } from "./SubCategoryView.vue?vue&type=template&id=2ba6d262&scoped=true"
import script from "./SubCategoryView.vue?vue&type=script&lang=js"
export * from "./SubCategoryView.vue?vue&type=script&lang=js"

import "./SubCategoryView.vue?vue&type=style&index=0&id=2ba6d262&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba6d262"]])

export default __exports__